<template lang="pug">
#accordion-multiplos-diagnosticos-socioambientais
    el-collapse(v-model='indexCollapseRow')
        el-collapse-item(
            v-for='(diagnostico, index) in dadosConsulta.diagnosticos',
            :key='index',
            :name='index'
        )
            template(slot='title')
                i.mr-2.flow.flow-verified.verde.mr8.custon-icon(
                    v-if='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "BAIXO") || (!diagnostico.nivelAlerta && diagnostico.resultados.length === 0)'
                )
                i.mr-2.flow.flow-warning-sign.amarelo.mr8.custon-icon(
                    v-else-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "MEDIO"'
                )
                i.mr-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
                    v-else-if='diagnostico.nivelAlerta && (diagnostico.nivelAlerta === "ALTO" || diagnostico.nivelAlerta === "MEDIO_ALTO")'
                )
                | {{ $t(`mensagens.camadas.${diagnostico.camada.codigo}`) }}
                div(v-if='diagnostico.resultados.length')
                    el-tag.custon-tag(
                        v-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "BAIXO"',
                        size='mini',
                        type='success'
                    ) {{ diagnostico.resultados.length }}
                    el-tag.custon-tag(
                        v-else-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "MEDIO"',
                        size='mini',
                        type='warning'
                    ) {{ diagnostico.resultados.length }}
                    el-tag.custon-tag(v-else, size='mini', type='danger') {{ diagnostico.resultados.length }}

            div(v-if='diagnostico && diagnostico.resultados.length')
                .card-opacidade(v-if='podeHabilitarOpacidade(diagnostico)')
                    .opacidade
                        span {{ $t('mensagens.diagnosticoSocioambiental.opacidade') }}: {{ diagnostico.opacidade }}
                        el-slider(
                            v-model='diagnostico.opacidade',
                            @input='atualizarOpacidade'
                        )
                component(
                    ref='componente',
                    v-bind:is='diagnostico.component',
                    v-bind='prepararDadosParaComponente(diagnostico)',
                    @aplicar-zoom-restricao='aplicarZoomRestricao'
                )

            .container-sem-restricoes(
                v-if='diagnostico.resultados.length === 0'
            )
                p {{ isRestricaoIna(diagnostico.camada.codigo, diagnostico.nivelAlerta) ? $t('mensagens.diagnosticoSocioambiental.inaConsultaErro') : $t('mensagens.diagnosticoSocioambiental.naoHaRestricoes') }}

            Fonte(
                :fonte='diagnostico.camada.fonte ? diagnostico.camada.fonte : {}'
            )

            el-button.float-right.my-3(
                type='primary',
                @click='downloadCertidao(diagnostico.cpfCnpj)',
                icon='el-icon-tickets',
                v-if='diagnostico.cpfCnpj && (diagnostico.camada.codigo === "AREA_EMBARGADA" || diagnostico.camada.codigo === "LISTA_AREA_EMBARGADA")'
            ) {{ $t('mensagens.diagnosticoSocioambiental.consultarCertidao') }}

            el-button.float-right.my-3(
                type='primary',
                @click='downloadCertidaoLdi(diagnostico.codigoCar)',
                icon='el-icon-tickets',
                v-if='diagnostico.codigoCar && diagnostico.camada.codigo === "LDI"'
            ) {{ $t('mensagens.diagnosticoSocioambiental.consultarCertidao') }}
</template>

<script>
import TerraIndigena from '@/components/diagnosticoSocioambiental/TerraIndigena.vue';
import TerraIndigenaParaguai from '@/components/diagnosticoSocioambiental/TerraIndigenaParaguai.vue';
import AreasSilvestresProtegidasParaguai from '@/components/diagnosticoSocioambiental/AreasSilvestresProtegidasParaguai.vue';
import AmazoniaProtege from '@/components/diagnosticoSocioambiental/AmazoniaProtege.vue';
import AreaEmbargada from '@/components/diagnosticoSocioambiental/AreaEmbargada.vue';
import Prodes from '@/components/diagnosticoSocioambiental/Prodes.vue';
import AreaEmbargadaIcmbio from '@/components/diagnosticoSocioambiental/AreaEmbargadaIcmbio.vue';
import AreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/AreaEmbargadaSemaMt.vue';
import AreaEmbargadaGoias from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoias';
import AreaEmbargadaGdf from './AreaEmbargadaGdf.vue';
import PovosComunidadesTradicionais from '@/components/diagnosticoSocioambiental/PovosComunidadesTradicionais.vue';
import Ldi from '@/components/diagnosticoSocioambiental/Ldi.vue';
import ListaAreaEmbargada from '@/components/diagnosticoSocioambiental/ListaAreaEmbargada.vue';
import ProtocoloVerdeGraos from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraos.vue';
import ListaSujaTrabalhoEscravo from '@/components/diagnosticoSocioambiental/ListaSujaTrabalhoEscravo.vue';
import ProdesCerrado from '@/components/diagnosticoSocioambiental/ProdesCerrado.vue';
import DeterAmazonia from '@/components/diagnosticoSocioambiental/DeterAmazonia.vue';
import DeterCerrado from '@/components/diagnosticoSocioambiental/DeterCerrado.vue';
import UnidadeConservacaoUs from '@/components/diagnosticoSocioambiental/UnidadeConservacaoUs.vue';
import UnidadeConservacaoPi from '@/components/diagnosticoSocioambiental/UnidadeConservacaoPi.vue';
import Queimadas from '@/components/diagnosticoSocioambiental/Queimadas.vue';
import SitiosArqueologicos from '@/components/diagnosticoSocioambiental/SitiosArqueologicos.vue';
import FaixaFronteira from '@/components/diagnosticoSocioambiental/FaixaFronteira.vue';
import PocAreaPlantadaGameleira from '@/components/diagnosticoSocioambiental/PocAreaPlantadaGameleira.vue';
import ImovelRural from '@/components/diagnosticoSocioambiental/ImovelRural.vue';
import Biomas from '@/components/diagnosticoSocioambiental/Biomas.vue';
import IncraSigefPublico from '@/components/diagnosticoSocioambiental/IncraSigefPublico.vue';
import IncraSigefPrivado from '@/components/diagnosticoSocioambiental/IncraSigefPrivado.vue';
import IncraAssentamentos from '@/components/diagnosticoSocioambiental/IncraAssentamentos.vue';
import IncraQuilombolas from '@/components/diagnosticoSocioambiental/IncraQuilombolas.vue';
import QuilombolasMaranhao from '@/components/diagnosticoSocioambiental/QuilombolasMaranhao.vue';
import DesmatamentoMapbiomas from '@/components/diagnosticoSocioambiental/desmatamento-mapbiomas.vue';
import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import AreaRelevanteInteresseEcologicoArie from '@/components/diagnosticoSocioambiental/AreaRelevanteInteresseEcologicoArie.vue';
import AreaProtecaoAmbientalApa from '@/components/diagnosticoSocioambiental/AreaProtecaoAmbientalApa.vue';
import AppCamada from '@/components/diagnosticoSocioambiental/AppCamada.vue';
import ReservaLegal from '@/components/diagnosticoSocioambiental/ReservaLegal.vue';
import UnidadeConservacao from '@/components/diagnosticoSocioambiental/UnidadeConservacao.vue';
import AreaPlantadaSojaCarMapbiomas from '@/components/diagnosticoSocioambiental/AreaPlantadaSojaCarMapbiomas.vue';
import AreaEmbargadaSedamRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaSedamRo.vue';
import ListaAreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaPiaui.vue';
import AreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/AreaEmbargadaPiaui.vue';
import ListaAreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaSemaMt.vue';
import AreaEmbargadaSigaMtPoligono from './AreaEmbargadaSigaMtPoligono.vue';
import AreaEmbargadaSigaMtPonto from './AreaEmbargadaSigaMtPonto.vue';
import AutoInfracaoIpaam from './AutoInfracaoIpaam.vue';
import TermoEmbargoIpaam from './TermoEmbargoIpaam.vue';
import EmbargosEmergenciaisIpaam from './EmbargosEmergenciaisIpaam.vue';
import AutosInfracaoFiscalizacaoIpaam from './AutosInfracaoFiscalizacaoIpaam.vue';
import AutosEmbargosIpaamPol from './AutosEmbargosIpaamPol.vue';
import EmbargosRemotosIpaam from './EmbargosRemotosIpaam.vue';
import AutoInfracaoGoPoligono from './AutoInfracaoGoPoligono.vue';
import AutoInfracaoGoPonto from './AutoInfracaoGoPonto.vue';
import RedFlag from './RedFlag.vue';
import YellowFlag from './YellowFlag.vue';
import AreaEmbargadaParana from '@/components/diagnosticoSocioambiental/AreaEmbargadaParana.vue';
import ProdesPantanal from './ProdesPantanal.vue';
import ProdesMataAtlantica from './ProdesMataAtlantica.vue';
import ProdesPampa from './ProdesPampa.vue';
import ProdesCaatinga from './ProdesCaatinga.vue';
import AreaEmbargadaAutoInfracaoSp from './AreaEmbargadaAutoInfracaoSp.vue';
import FlorestasPublicas from '@/components/diagnosticoSocioambiental/FlorestasPublicas.vue';
import AreaEmbargadaRs from '@/components/diagnosticoSocioambiental/AreaEmbargadaRs.vue';
import AreaEmbargadaGoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoPonto.vue';
import FincasParaguai from '@/components/diagnosticoSocioambiental/FincasParaguai.vue';
import DesmatamentoInfonaParaguai from './DesmatamentoInfonaParaguai.vue';
import DesmatamentoInfonaParaguai2020 from './DesmatamentoInfonaParaguai2020.vue';
import DesmatamentoParaguaiVega from './DesmatamentoParaguaiVega.vue';
import DesmatamentoInfonaParaguai2024 from './DesmatamentoInfonaParaguai2024.vue';
import DesmatamentoVegaComSoja2324VegaParaguai from './DesmatamentoVegaComSoja2324VegaParaguai.vue';
import DesmatamentoVega2025ComSoja2425VegaParaguai from './DesmatamentoVega2025ComSoja2425VegaParaguai.vue';
import PastizalParaguai from './PastizalParaguai.vue';
import PastizalInundableParaguai from './PastizalInundableParaguai.vue';
import AreasEmbargadasTo from '@/components/diagnosticoSocioambiental/AreasEmbargadasTo.vue';
import AutoInfracaoTo from '@/components/diagnosticoSocioambiental/AutoInfracaoTo.vue';
import EmbargosGoLista from '@/components/diagnosticoSocioambiental/EmbargosGoLista.vue';
import SojaSafra2324Paraguay from '@/components/diagnosticoSocioambiental/SojaSafra2324Paraguay.vue';
import SojaParaguai2022 from '@/components/diagnosticoSocioambiental/SojaParaguai2022.vue';
import AreaPlantadaSojaParaguai20242025 from './AreaPlantadaSojaParaguai20242025.vue';
import AreaPlantadaSojaParaguai20252026 from './AreaPlantadaSojaParaguai20252026.vue';
import ProdesResiduos from './ProdesResiduos.vue';
import ProdesResiduosAmazonia from './ProdesResiduosAmazonia.vue';
import ProdesResiduosCaatinga from './ProdesResiduosCaatinga.vue';
import ProdesResiduosCerrado from './ProdesResiduosCerrado.vue';
import ProdesResiduosMataAtlantica from './ProdesResiduosMataAtlantica.vue';
import ProdesResiduosPampa from './ProdesResiduosPampa.vue';
import ProdesResiduosPantanal from './ProdesResiduosPantanal.vue';
import AutoInfracaoRs from './AutoInfracaoRs.vue';
import QuilombolasBa from './QuilombolasBa.vue';
import AutoInfracaoPi from '@/components/diagnosticoSocioambiental/AutoInfracaoPi.vue';
import AreaEmbargadaPa from '@/components/diagnosticoSocioambiental/AreaEmbargadaPa.vue';
import EudrForestCover2020 from '@/components/diagnosticoSocioambiental/EudrForestCover2020.vue';
import CsaCerrado from '@/components/diagnosticoSocioambiental/CsaCerrado.vue';
import ReservaBiosferaParaguai from '@/components/diagnosticoSocioambiental/ReservaBiosferaParaguai.vue';
import SitioRamsarParaguai from '@/components/diagnosticoSocioambiental/SitioRamsarParaguai.vue';
import ReservaProvinciale from '@/components/diagnosticoSocioambiental/ReservaProvinciale.vue';
import Prodes2008 from '@/components/diagnosticoSocioambiental/Prodes2008.vue';
import Prodes2009 from '@/components/diagnosticoSocioambiental/Prodes2009.vue';
import Prodes2010 from '@/components/diagnosticoSocioambiental/Prodes2010.vue';
import Prodes2011 from '@/components/diagnosticoSocioambiental/Prodes2011.vue';
import Prodes2012 from '@/components/diagnosticoSocioambiental/Prodes2012.vue';
import Prodes2013 from '@/components/diagnosticoSocioambiental/Prodes2013.vue';
import Prodes2014 from '@/components/diagnosticoSocioambiental/Prodes2014.vue';
import Prodes2015 from '@/components/diagnosticoSocioambiental/Prodes2015.vue';
import Prodes2016 from '@/components/diagnosticoSocioambiental/Prodes2016.vue';
import Prodes2017 from '@/components/diagnosticoSocioambiental/Prodes2017.vue';
import Prodes2018 from '@/components/diagnosticoSocioambiental/Prodes2018.vue';
import Prodes2019 from '@/components/diagnosticoSocioambiental/Prodes2019.vue';
import Prodes2020 from '@/components/diagnosticoSocioambiental/Prodes2020.vue';
import Prodes2021 from '@/components/diagnosticoSocioambiental/Prodes2021.vue';
import Prodes2022 from '@/components/diagnosticoSocioambiental/Prodes2022.vue';
import Prodes2023 from '@/components/diagnosticoSocioambiental/Prodes2023.vue';
import Prodes2024 from '@/components/diagnosticoSocioambiental/Prodes2024.vue';
import AreaEmbargadaCePonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaCePonto.vue';
import AreaEmbargadaCe from '@/components/diagnosticoSocioambiental/AreaEmbargadaCe.vue';
import AreaEmbargadaIbamaPoligonoPamgia from '@/components/diagnosticoSocioambiental/AreaEmbargadaIbamaPoligonoPamgia.vue';
import AreaEmbargadaRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaRo.vue';
import AreaEmbargadaRoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaRoPonto.vue';
import PlantioDesmatamentoRedFlag from '@/components/diagnosticoSocioambiental/PlantioDesmatamentoRedFlag.vue';
import DesmatamentoArgentina2025 from './DesmatamentoArgentina2025.vue';
import PastizalConvertidoACultivoParaguay from './PastizalConvertidoACultivoParaguay.vue';
import AreaPlantadaBunge2024 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2024.vue';
import AreaPlantadaBunge2025 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2025.vue';
import AreaPlantadaBunge2026 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2026.vue';
import DesmatamentoParaguaiVega2025 from './DesmatamentoParaguaiVega2025.vue';
import SojaEmProdes2425 from '@/components/diagnosticoSocioambiental/SojaEmProdes2425.vue';
import ProtocoloVerdeGraosStatusOk from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraosStatusOk.vue';
import ProtocoloVerdeGraosStatusRestricao from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraosStatusRestricao.vue';
import TerraIndigenaStatusDelimitado from '@/components/diagnosticoSocioambiental/TerraIndigenaStatusDelimitado.vue';
import TerraIndigenaStatusDeclarado from '@/components/diagnosticoSocioambiental/TerraIndigenaStatusDeclarado.vue';
import ControleDesmatamentoAmazonia from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazonia.vue';
import ControleDesmatamentoAmazoniaConsolidada from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazoniaConsolidada.vue';
import ControleDesmatamentoAmazoniaPontos from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazoniaPontos.vue';
import EmbargosGoInaConsultaLista from '@/components/diagnosticoSocioambiental/EmbargoGoInaConsultaLista.vue';
import DenunciasProdutoresBunge from '@/components/diagnosticoSocioambiental/DenunciasProdutoresBunge.vue';
import FootprintBungeEdible from '@/components/diagnosticoSocioambiental/FootprintBungeEdible.vue';
import FootprintBungeFabrica from '@/components/diagnosticoSocioambiental/FootprintBungeFabrica.vue';
import FootprintBungeMoinhoTrigo from '@/components/diagnosticoSocioambiental/FootprintBungeMoinhoTrigo.vue';
import FootprintBungePorto from '@/components/diagnosticoSocioambiental/FootprintBungePorto.vue';
import FootprintBungeSilos from '@/components/diagnosticoSocioambiental/FootprintBungeSilos.vue';

// O nome dos componentes (arquivos) de camadas devem seguir o codigo da camada em CamelCase
// Exemplo do arquivo: camada codigo SIGEF_PUBLICO = SigefPublico.vue
// O atributo name dos componentes deve ser o codigo da camada separado por -
// Exemplo do name: camada codigo SIGEF_PUBLICO = sigef-publico

export default {
    name: 'DiagnosticosSocioambientais',

    emits: ['index-aberto', 'inibir-restricao'],

    components: {
        TerraIndigena,
        TerraIndigenaParaguai,
        AreasSilvestresProtegidasParaguai,
        AmazoniaProtege,
        AreaEmbargada,
        Prodes,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        AreaEmbargadaGoias,
        AreaEmbargadaGdf,
        PovosComunidadesTradicionais,
        Ldi,
        ListaAreaEmbargada,
        ProtocoloVerdeGraos,
        ListaSujaTrabalhoEscravo,
        ProdesCerrado,
        DeterAmazonia,
        DeterCerrado,
        UnidadeConservacaoUs,
        UnidadeConservacaoPi,
        Queimadas,
        SitiosArqueologicos,
        FaixaFronteira,
        PocAreaPlantadaGameleira,
        ImovelRural,
        Biomas,
        IncraSigefPublico,
        IncraSigefPrivado,
        IncraAssentamentos,
        IncraQuilombolas,
        QuilombolasMaranhao,
        DesmatamentoMapbiomas,
        Fonte,
        AreaRelevanteInteresseEcologicoArie,
        AreaProtecaoAmbientalApa,
        AppCamada,
        ReservaLegal,
        UnidadeConservacao,
        AreaPlantadaSojaCarMapbiomas,
        AreaEmbargadaSedamRo,
        ListaAreaEmbargadaPiaui,
        AreaEmbargadaPiaui,
        ListaAreaEmbargadaSemaMt,
        AreaEmbargadaSigaMtPoligono,
        AreaEmbargadaSigaMtPonto,
        AutoInfracaoIpaam,
        TermoEmbargoIpaam,
        EmbargosEmergenciaisIpaam,
        AutosInfracaoFiscalizacaoIpaam,
        AutosEmbargosIpaamPol,
        EmbargosRemotosIpaam,
        AutoInfracaoGoPoligono,
        AutoInfracaoGoPonto,
        AreaEmbargadaParana,
        ProdesPantanal,
        ProdesMataAtlantica,
        ProdesPampa,
        ProdesCaatinga,
        RedFlag,
        YellowFlag,
        AreaEmbargadaAutoInfracaoSp,
        FlorestasPublicas,
        AreaEmbargadaRs,
        AreaEmbargadaGoPonto,
        FincasParaguai,
        DesmatamentoInfonaParaguai,
        DesmatamentoInfonaParaguai2020,
        DesmatamentoInfonaParaguai2024,
        DesmatamentoParaguaiVega,
        PastizalParaguai,
        PastizalInundableParaguai,
        AreasEmbargadasTo,
        AutoInfracaoTo,
        EmbargosGoLista,
        SojaSafra2324Paraguay,
        SojaParaguai2022,
        ProdesResiduos,
        ProdesResiduosAmazonia,
        ProdesResiduosCaatinga,
        ProdesResiduosCerrado,
        ProdesResiduosMataAtlantica,
        ProdesResiduosPampa,
        ProdesResiduosPantanal,
        CsaCerrado,
        AutoInfracaoRs,
        QuilombolasBa,
        AutoInfracaoPi,
        AreaEmbargadaPa,
        EudrForestCover2020,
        ReservaBiosferaParaguai,
        SitioRamsarParaguai,
        ReservaProvinciale,
        Prodes2008,
        Prodes2009,
        Prodes2010,
        Prodes2011,
        Prodes2012,
        Prodes2013,
        Prodes2014,
        Prodes2015,
        Prodes2016,
        Prodes2017,
        Prodes2018,
        Prodes2019,
        Prodes2020,
        Prodes2021,
        Prodes2022,
        Prodes2023,
        Prodes2024,
        AreaEmbargadaCe,
        AreaEmbargadaCePonto,
        AreaEmbargadaIbamaPoligonoPamgia,
        AreaEmbargadaRo,
        AreaEmbargadaRoPonto,
        PlantioDesmatamentoRedFlag,
        DesmatamentoArgentina2025,
        DesmatamentoVegaComSoja2324VegaParaguai,
        DesmatamentoVega2025ComSoja2425VegaParaguai,
        AreaPlantadaSojaParaguai20242025,
        AreaPlantadaSojaParaguai20252026,
        PastizalConvertidoACultivoParaguay,
        AreaPlantadaBunge2024,
        AreaPlantadaBunge2025,
        AreaPlantadaBunge2026,
        DesmatamentoParaguaiVega2025,
        SojaEmProdes2425,
        ProtocoloVerdeGraosStatusOk,
        ProtocoloVerdeGraosStatusRestricao,
        TerraIndigenaStatusDelimitado,
        TerraIndigenaStatusDeclarado,
        ControleDesmatamentoAmazonia,
        ControleDesmatamentoAmazoniaConsolidada,
        ControleDesmatamentoAmazoniaPontos,
        EmbargosGoInaConsultaLista,
        DenunciasProdutoresBunge,
        FootprintBungeEdible,
        FootprintBungeFabrica,
        FootprintBungeMoinhoTrigo,
        FootprintBungePorto,
        FootprintBungeSilos
    },

    props: {
        dadosConsulta: {
            type: Object,
            required: true
        },
        indexDiagnostico: {
            type: Object,
            required: false,
            default: null
        },
        habilitarOpacidade: {
            type: Boolean,
            required: false,
            default: false
        },
        mapaLeaflet: {
            type: Object,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        },
        statusCollapse: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            indexCollapseRow: ''
        };
    },

    watch: {
        indexCollapseRow: function () {
            this.$emit(
                'index-aberto',
                null,
                this.indexDiagnostico.index,
                this.indexCollapseRow
            );
        },
        statusCollapse: {
            handler(value) {
                /**
                 * Esse handler será chamado
                 * quando o collapse principal
                 * for fechado
                 */
                if (value && !value.status) {
                    // fecha o collapse das restrições
                    this.indexCollapseRow = '';

                    /**
                     * Reseta a opacidade de todas as restrições
                     * do collase principal que foi fechado
                     */
                    this.dadosConsulta.diagnosticos =
                        this.dadosConsulta.diagnosticos.map(diagnostico => {
                            return { ...diagnostico, opacidade: 100 };
                        });
                }
            },
            deep: true
        }
    },

    methods: {
        atualizarOpacidade(opacidade) {
            this.$forceUpdate();
            if (
                typeof indexsRestricao === 'string' &&
                this.indexCollapseRow === ''
            ) {
                return;
            }

            if (this.indexCollapseRow?.filter) {
                const filtrado = this.indexCollapseRow.filter(f => f !== '');

                const group = `grupo-restricoes-${this.indexDiagnostico.index}-${filtrado}`;
                const layers = Object.values(
                    this.mapaLeaflet.mapa._layers
                ).filter(l => l.group === group);

                if (layers && opacidade >= 0) {
                    const novaOpacidade = opacidade / 200;
                    layers.forEach(layer =>
                        layer.setStyle({
                            fillOpacity: novaOpacidade,
                            opacity: novaOpacidade
                        })
                    );
                }
            }
        },

        prepararDadosParaComponente(diagnostico) {
            return {
                restricoes: diagnostico.resultados,
                geometria: diagnostico.geometria,
                habilitarZoomRestricao: this.habilitarZoomRestricao,
                cpfCnpj: diagnostico.cpfCnpj
            };
        },

        downloadCertidao(cpfCnpj) {
            cpfCnpj = cpfCnpj.replaceAll('-', '').replaceAll('.', '');
            const url = `https://servicos.ibama.gov.br/ctf/publico/areasembargadas/ConsultaPublicaAreasEmbargadas.php?modulo=publico/areasembargadas/CertidaoNadaConsta.php&$bvars=${cpfCnpj}&ajax=1&fpdf=1`;
            window.open(url, '_blank');
        },

        downloadCertidaoLdi(car) {
            const url = `https://monitoramento.semas.pa.gov.br/ldi/imoveis/downloadcertidaodesmatamento?codigoImovel=${car}`;
            window.open(url, '_blank');
        },

        podeHabilitarOpacidade(diagnostico) {
            if (!this.habilitarOpacidade || !diagnostico) return false;

            if (diagnostico.geometria?.length) return true;

            const restricoesSemGeometria = diagnostico.resultados.filter(
                resultado =>
                    !(
                        resultado.geometry ||
                        resultado.geometria ||
                        resultado.properties?.geometry ||
                        resultado.properties?.geometria ||
                        resultado.propriedade?.geometry ||
                        resultado.propriedade?.geometria
                    )
            );

            return (
                restricoesSemGeometria.length < diagnostico.resultados.length
            );
        },

        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes,
            index
        ) {
            let geoJson =
                restricao.geometry ||
                restricao.geometria ||
                restricao.properties?.geometry ||
                restricao.properties?.geometria ||
                restricao.propriedade?.geometry ||
                restricao.propriedade?.geometria ||
                geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                !geoJson &&
                restricao.properties?.latitude &&
                restricao.properties?.longitude
            ) {
                geoJson = {
                    type: 'Point',
                    coordinates: [
                        restricao.properties.longitude,
                        restricao.properties.latitude
                    ]
                };
            }

            const group = Object.values(this.mapaLeaflet.mapa._layers).filter(
                d =>
                    d.group ===
                    `grupo-restricoes-${this.indexDiagnostico.index}-${this.indexCollapseRow}`
            );
            group.forEach(layer =>
                layer.setStyle({ color: 'red', weight: 1, fill: true })
            );

            const layer = Object.values(this.mapaLeaflet.mapa._layers).find(
                d =>
                    d.name ===
                    `AreaDiagnostico_red_${this.indexDiagnostico.index}_${this.indexCollapseRow}_${index}`
            );

            if (layer) {
                layer.setStyle({ color: 'orange', weight: 1, fill: true });
            }
            if (geoJson.type === 'Point') {
                this.mapaLeaflet.mapa.setView(
                    [geoJson.coordinates[1], geoJson.coordinates[0]],
                    18
                );
            } else {
                this.mapaLeaflet.aplicarZoomGeoJson(geoJson);
            }
        },

        fecharCollapses() {
            // fecha o collapse das restrições
            this.indexCollapseRow = '';

            /**
             * Reseta a opacidade de todas as restrições
             * do collase principal que foi fechado
             */
            this.dadosConsulta.diagnosticos =
                this.dadosConsulta.diagnosticos.map(diagnostico => {
                    return { ...diagnostico, opacidade: 100 };
                });
        },

        isRestricaoIna(codigo, nivelAlerta) {
            if (codigo === 'EMBARGOS_GO_INA_CONSULTA_LISTA' && nivelAlerta === 'MEDIO') return true;

            return false;
        }
    }
};
</script>

<style lang="scss">
#accordion-multiplos-diagnosticos-socioambientais {
    .el-collapse-item__header {
        font-weight: bold;
        color: var(--primary-font-color);
    }

    p {
        line-height: 1.7692307692 !important;
    }

    .card-restricao {
        background-color: #fafafa;
        border: 1px solid #eaeefb;
        border-radius: 4px;
        padding: 10px 10px 0px 20px;
        margin-bottom: 20px;
    }

    .card-restricao--ativo {
        border: 1px solid var(--primary);
    }

    .container-restricao-acoes {
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
    }

    .container-sem-restricoes {
        p {
            margin-left: 20px;
        }
    }
}

.vermelho {
    color: red;
}

.amarelo {
    color: #d7bc25;
}

.verde {
    color: green;
}

.certidao {
    color: var(--white) !important;
    background: var(--primary) !important;
}

.custon-tag {
    border-radius: 12px;
    margin-left: 5px;
}

.custon-icon {
    font-size: 16px;
    font-weight: bold;
}

.el-tag--mini {
    height: 17px !important;
    padding: 0 5px !important;
    line-height: 17px !important;
    border-radius: 10px !important;
}

.card-opacidade {
    margin-bottom: 20px !important;
    word-wrap: break-word !important;
    background-color: #fff !important;
    background-clip: border-box !important;
    border: 1px solid rgba(0, 0, 0, 0.13) !important;
    border-radius: 0.25rem !important;
    padding: 5px !important;

    .opacidade {
        display: block;
        padding: 0 20px;

        span {
            font-weight: bolder;
        }

        .el-slider {
            width: 97%;
            height: 20px;
        }
    }
}
</style>
